import * as z from 'zod';
import { logError } from '../../logging/log-error.helper';
var eventBaseSchema = z.object({
    sessionId: z.string().uuid(),
    path: z.string(),
    timestamp: z.string(),
    source: z.object({
        hostname: z.string(),
        origin: z.string().url(),
    }),
    type: z.string(),
    widget: z.string(),
});
export function getEventBase(_a) {
    var type = _a.type, widget = _a.widget, sessionId = _a.sessionId;
    var event = {
        sessionId: sessionId,
        type: type,
        path: window.location.pathname,
        timestamp: Math.floor(Date.now() / 1000).toString(),
        source: {
            hostname: window.location.hostname,
            origin: window.location.origin,
        },
        widget: widget,
    };
    try {
        return eventBaseSchema.parse(event);
    }
    catch (error) {
        logError({
            error: error,
            message: 'Base event validation failed',
            tag: {
                name: 'type-validation',
                value: 'failed',
            },
            level: 'error',
            metadata: {
                event: event,
                validationError: error instanceof z.ZodError ? error.issues : null,
            },
        });
    }
}
